var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3538_5465)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.0179 12.9986L20.0052 7.01139C20.1235 6.87323 20.1853 6.69551 20.1783 6.51374C20.1713 6.33198 20.0959 6.15955 19.9673 6.03093C19.8387 5.90231 19.6662 5.82696 19.4845 5.81993C19.3027 5.81291 19.125 5.87474 18.9868 5.99306L12.9996 11.9803L7.01238 5.98584C6.87638 5.84984 6.69193 5.77344 6.4996 5.77344C6.30727 5.77344 6.12282 5.84984 5.98682 5.98584C5.85083 6.12183 5.77442 6.30629 5.77442 6.49861C5.77442 6.69094 5.85083 6.8754 5.98682 7.01139L11.9813 12.9986L5.98682 18.9858C5.91122 19.0506 5.84982 19.1303 5.80647 19.2199C5.76312 19.3095 5.73876 19.4071 5.73491 19.5065C5.73107 19.606 5.74783 19.7052 5.78414 19.7978C5.82045 19.8905 5.87553 19.9747 5.94591 20.0451C6.01629 20.1155 6.10047 20.1705 6.19315 20.2069C6.28582 20.2432 6.38501 20.2599 6.48447 20.2561C6.58394 20.2522 6.68153 20.2279 6.77113 20.1845C6.86074 20.1412 6.94041 20.0798 7.00516 20.0042L12.9996 14.0169L18.9868 20.0042C19.125 20.1225 19.3027 20.1843 19.4845 20.1773C19.6662 20.1703 19.8387 20.0949 19.9673 19.9663C20.0959 19.8377 20.1713 19.6653 20.1783 19.4835C20.1853 19.3017 20.1235 19.124 20.0052 18.9858L14.0179 12.9986Z",
    fill: "#AEB7C9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3538_5465"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.1db681b36d33483a9a0d3a8a5004cd9f.svg";
export { ForwardRef as ReactComponent };